<template>
    <div>
        <z-title title="咨询提醒" ref="title"></z-title>
        <el-row :gutter="20">
            <el-col :span="17">
                <z-calendar1 name="咨询" :impList="impList" @add="addConsult" @getDate="getDate"
                             @getDateRange="getDateRange" ref="search"></z-calendar1>
                <el-card>
                    <el-table
                            v-loading="loading"
                            :height="height+'px'"
                            highlight-current-row
                            element-loading-text="列表刷新中"
                            element-loading-spinner="el-icon-loading"
                            header-cell-class-name="headerrow"
                            cell-class-name="cellclass"
                            :data="dataList"
                            style="width: 100%">
                        <el-table-column
                                fixed
                                align="center"
                                prop="customName"
                                label="用户姓名"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="phone"
                                label="电话"
                                width="120"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="wechatNo"
                                label="微信"
                                width="120"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="wantCount"
                                label="意向人数"
                                width="100"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="wantDate"
                                label="意向日期"
                                width="120"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                label="时间段"
                                width="100"
                                align="center">
                            <template slot-scope="scope">
                                {{scope.row.wantBeginTime?(scope.row.wantBeginTime+'-'+scope.row.wantEndTime):''}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="意向场地"
                                width="180"
                                prop="wantHouseContent"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                label="备注内容"
                                min-width="220"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="120"
                                align="center">
                            <template slot-scope="scope">
                                <template v-if="new Date($TM.getDayArea().date).getTime()<=new Date(scope.row.wantDate).getTime()">
                                    <el-button type="text" size="small"
                                               @click="gotoHandle(scope.row.id,scope.row.wantDate)">处理
                                    </el-button>
                                    <el-button type="text" size="small" @click="editReserve(scope.row)">预定</el-button>
                                </template>
                                <template v-else>
                                    <el-button type="text" size="small" @click="editConsult(scope.row.id)">编辑</el-button>
                                    <el-button type="text" size="small" @click="gotoHandle(scope.row.id,null)">查看处理
                                    </el-button>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                                @currentChange="handleCurrentChange"></pagination>
                </el-card>
            </el-col>
            <el-col :span="7">
                <z-dateselect @getDaterange="getDaterangeselect"></z-dateselect>
                <z-little-card title="咨询总次数" :num="askAnalysis.askCount" subtitle="日均次数"
                               :subnum="askAnalysis.askDayCount" icon="icon-shenhe"></z-little-card>
                <z-little-card title="成交总次数（已预定）" :num="askAnalysis.dealCount" subtitle="日均次数"
                               :subnum="askAnalysis.dealDayCount" icon="icon-chengjiao"></z-little-card>
                <z-little-card title="成交率（已预定➗全部咨询）" :num="askAnalysis.dealRate*100+'%'"
                               icon="icon-icon_A"></z-little-card>
                <z-little-card title="失效率（已失效➗全部咨询）" :num="askAnalysis.failRate*100+'%'"
                               icon="icon-icon_A-copy"></z-little-card>
                <z-little-card title="确认率（已确认➗全部咨询）" :num="askAnalysis.confirmRate*100+'%'" icon="icon-icon_A-copy-copy"></z-little-card>
            </el-col>
        </el-row>
        <consultation :id="id" :visible.sync="showdialog" v-model="askForm" :type="editstate" @refresh="refreshList"></consultation>
        <books :visible.sync="showorder" v-model="orderForm" type="新增"  @refresh="refreshList"></books>
        <!--处理咨询-->
        <handle-consult :visible.sync="showconsult" :id="askId" :wantDate="wantDate" @change="consultChange"></handle-consult>


    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import ZCalendar1 from "../../components/ZCalendar1";
    import ZDateselect from "../../components/ZDateselect";
    import ZLittleCard from "../../components/ZLittleCard";
    import Consultation from "../component/consultation";
    import Books from "../component/books";
    import ElForm from "element-ui/packages/form/src/form";
    import ElCollapse from "element-ui/packages/collapse/src/collapse";
    import ElButton from "element-ui/packages/button/src/button";
    import HandleConsult from "./sub/handleConsult";
    import Pagination from "../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            HandleConsult,
            ElButton,
            ElCollapse,
            ElForm,
            Books,
            Consultation,
            ZLittleCard,
            ZDateselect,
            ZCalendar1,
            ZTitle
        },
        name: "remind",
        data() {
            return {
                addloading:false,
                loading: false,
                currentPage: 1,
                pageSize: 20,
                total: 0,
                height: 250,

                editstate:'新增',
                
                chooseDate: '',
                wantDate: null,

                
                impList: [],
                askAnalysis: {
                    "askCount": 12,
                    "askDayCount": 11,
                    "dealCount": 5,
                    "dealDayCount": 2,
                    "dealRate": 0.53,
                    "failRate": 0.47
                },
                dataList: [],
                timearea:[],
                showdialog: false,
                showconsult: false,
                //咨询数据表单
                askForm: {
                    customName: '',//客户名称
                    phone: '',//手机号
                    wechatNo: '',//微信号
                    userCount: '',//意向人数
                    wantDate: '',//意向日期
                    alertDate: '',//提醒日期
                    userFrom: '',//用户来源
                    moneyStart: '',//预期起
                    moneyEnd: '',//预期止
                    wantLevel: '',//意向程度
                    wantHouse: '',//意向场地
                    remark: '',//备注
                },
                
                askId: '',//咨询单id
                id:'',

                // 预定相关
                //套餐列表
                setmealList: [],
                showorder: false,
                //预定数据
                orderForm: {
                    name: '',//姓名
                    tel: '',//电话
                    booksdate: '',//预定日期
                    startTime: '',//时间段开始
                    endTime: '',//时间段结束
                    intentpart: '',//预定场地
                    intenttype: '',//预定类型
                    payway: '1',//收费方式
                    everyprice: 0,//每人价格
                    booksnum: 0,//预定人数
                    everytable: 0,//每桌价格
                    bookstables: 0,//预定桌数
                    sparetables: 0,//备用桌数
                    packageprice: 0,//包场价格
                    booksmeals: '',//预定套餐
                    booksunitprice: '',//预定单价
                    additemprice: '',//添加项目合计金额
                    handsel: '',//已收定金
                    reminddate: '',//提醒日期
                    totalprice: 0.00,//总计应收
                    bookstate: '1',//预定状态
                    comefrom: '',//顾客来源
                    remarks: ''//备注
                },


            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 190;
                console.log(this.height)
            },0)
        },
        methods: {
            //咨询处理改变
            consultChange(){
                this.getDataList();
                this.askAlertList(this.timearea);
            },
            getDateRange(daterange) {
                this.askAlertList(daterange)
            },
            //咨询提醒列表（重点日期表头部分）
            askAlertList(daterange) {
                console.log(daterange)
                this.timearea=daterange;
                this.$axios.post('/preUserAsk/askAlertList', {
                    "storeId": this.$root.getStorage('storeId'),
                    "startTime": daterange[0].date,
                    "endTime": daterange[6].date
                }).then(res => {
                    console.log( '咨询提醒表头', res)
                    this.impList = res.data.list
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },

            //新增咨询
            addConsult() {
                this.showdialog = true;
            },
            //编辑咨询
            editConsult(id){
                console.log('编辑',id)
                this.id=id;
                this.editstate='编辑';
                this.$axios.get('/preUserAsk/findById/'+id).then(res=>{
                    console.log('编辑查看数据',res)
                    var data=res.data;
                    var wantHouse=[]
                    for(var i in data.wantHouse){
                        if(data.wantHouse[i])
                        wantHouse.push({id:data.wantHouse[i].houseId,houseName:data.wantHouse[i].houseName})
                    }
                    data.wantHouse=wantHouse;
                    data.userFrom={
                        dicCode:data.customFromId,
                        dicName:data.customFromName
                    }
                    this.askForm=data;
                    this.showdialog=true;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //编辑预定
            editReserve(row) {
                console.log(row)
                this.$axios.get('/preUserAsk/findById/'+row.id).then(res=>{
                    console.log('查看数据',res)
                    var data=res.data;
                    data.orderDate=data.wantDate;
                    var wanthouse={};
                    for(var i in data.wantHouse){
                        if(data.wantHouse[i]){
                            wanthouse=data.wantHouse[i];
                            data.houseId=wanthouse.houseId;
                            data.houseTypeCode=wanthouse.house_type_code;
                        }
                    }

                    data.askId=data.id;
                    this.orderForm=data;
                    this.showorder = true;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })

            },
            //根据咨询记录id查看处理明细,显示10条
            gotoHandle(askId, wantDate) {
                console.log(askId)
                this.wantDate = wantDate;
                this.askId = askId;
                this.showconsult = true;
            },

            //获取日期区间根据区间查询咨询数据
            getDaterangeselect(data) {
                this.$axios.post('/preUserAsk/askAnalysis', {
                    "storeId": this.$root.getStorage('storeId'),
                    "startTime": data[0],
                    "endTime": data[1]
                }).then(res => {
                    console.log(res)
                    this.askAnalysis = res.data;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //获取当前日期
            getDate(date) {
                this.chooseDate = date.date;
                this.currentPage = 1;
                this.getDataList();
            },
            //获取当前日期数据
            getDataList() {
                this.loading = true;
                this.$axios.post('/preUserAsk/askAlertByDate', {
                    "storeId": this.$root.getStorage('storeId'),
                    "askDate": this.chooseDate,
                    "currentPage": this.currentPage,
                    "pageSize": this.pageSize
                }).then(res => {
                    console.log('获取', this.chooseDate, '数据', res.data)
                    this.dataList = res.data.list;
                    for(var i in this.dataList){
                        var content='';
                        for(var j in this.dataList[i].wantHouse){
                            if(this.dataList[i].wantHouse[j]){
                                content +=this.dataList[i].wantHouse[j].houseName+'、'
                            }
                        }
                        if(content.length>0){
                            this.$set(this.dataList[i],'wantHouseContent',content.substring(0,content.length-1))
                        }
                    }
                    this.total = res.data.total;
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg)
                    this.loading = false;
                })
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pageSize = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.currentPage = val;
                this.getDataList();
            },
            //刷新列表
            refreshList() {
                this.currentPage = 1;
                this.getDataList();
                this.askAlertList(this.timearea);

            }
        },
    }
</script>

<style scoped lang="scss">
    .pagination {
        height: 50px;
        background: #f2f2f2;
    }

    .doconsult {
        .right {
            background: #f7f7f7;
            padding: 0 10px;
            height: fit-content;
        }
    }
</style>
<style>

</style>